<template>
  <section class="destinations defaultSectionMargins">
    <div class="container">
      <div class="destinations__Intro">
        <div>
          <h2 v-text="data.title" />
          <p v-text="data.description" />
          <Button type="nuxt-link" :to="link('PlaceList')" secondary medium>{{ data.cta_text }}</Button>
        </div>
  
        <div>
          <Flare :srcset="data.image" size="both" width="600" height="600" crop="fill" :alt="data.image" />
        </div>
      </div>
  
      <div class="destinations__SliderWrapper">
        <FlickitySlider with-progress :options="flickityOptions" class="mediumArrows">
          <div v-for="(destination, index) in places" class="destinations__Item">
            <div class="destinationListing__ImageWrapper">
              <Flare :srcset="destination.image" size="both" width="600" height="800" crop="fill" :alt="destination.image" />
            </div>
            <div class="destinations__ItemContent">
              <h3>{{ destination.name }}</h3>
              <p>{{ $t('property', destination.accommodation_count) }}</p>
            </div>
            <nuxt-link v-if="destination.sef" :to="destination.sef">{{ destination.name }}</nuxt-link>
          </div>
        </FlickitySlider>
      </div>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {},
  })

  const { link } = useSetup();
  const { initialData: { value: {places}} } = useSetup();

  const flickityOptions = {
    pageDots: false,
    contain: true,
    cellAlign: 'left',
  };
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_destinations.scss');
</style>